import type { InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material';
import { InputAdornment as MuiInputAdornment } from '@mui/material';

export type InputAdornmentProps = MuiInputAdornmentProps;

/** This can be used to add a prefix, a suffix, or an action to an input. For instance, you can use an icon button to hide or reveal the password.
 https://mui.com/material-ui/react-text-field/#input-adornments 
 */
export const InputAdornment = (props: InputAdornmentProps) => <MuiInputAdornment {...props} />;
